import React, { useState, useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronLeft, faChevronRight } from "@fortawesome/free-solid-svg-icons";
import axios from "axios";
import './Blog.css';

const Blog = () => {
    const [stories, setStories] = useState([]);
    const [currentList, setCurrentList] = useState([]);
    const [count, setCount] = useState(0);

    const fetchCurrentList = (c) => {
        if (c === -1 && count > 1) {
            let start = (count - 2) * 8;
            let end = (count - 1) * 8;
            end = end <= stories.length ? end : stories.length;
            let cList = stories.slice(start, end);
            setCount(count - 1);
            setCurrentList(cList);
            document.body.scrollTop = 0;
            document.documentElement.scrollTop = 0;
        }
        else if (c === 1 && stories.length > (count * 10)) {
            let start = count * 8;
            let end = (count + 1) * 8;
            end = end <= stories.length ? end : stories.length;
            let cList = stories.slice(start, end);
            setCount(count + 1);
            setCurrentList(cList);
            document.body.scrollTop = 0;
            document.documentElement.scrollTop = 0;
        }
        else {
            return;
        }
    }

    const fetchStories = () => {
        axios.get('https://lerntutors.com/react_2026_api/stories/gueststories.php')
        .then(res => res.data)
        .then(data => {
            let cList = data.slice(0, 8);
            setStories(data);
            setCurrentList(cList);
            setCount(1);
        });
    }

    useEffect(() => {
        let mounted = true;
        if (mounted) {
            fetchStories();
        }
        return () => mounted = false;
    }, [])

    return (
        <div className="lern-blog">
            <div className="catch-div">
                <div className="wave-div wave-one">
                    <svg className="catch-svg svg-one" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="none" viewBox="0 0 1440 320"><path fill-opacity="1" d="M0,224L34.3,208C68.6,192,137,160,206,165.3C274.3,171,343,213,411,213.3C480,213,549,171,617,181.3C685.7,192,754,256,823,256C891.4,256,960,192,1029,176C1097.1,160,1166,192,1234,213.3C1302.9,235,1371,245,1406,250.7L1440,256L1440,0L1405.7,0C1371.4,0,1303,0,1234,0C1165.7,0,1097,0,1029,0C960,0,891,0,823,0C754.3,0,686,0,617,0C548.6,0,480,0,411,0C342.9,0,274,0,206,0C137.1,0,69,0,34,0L0,0Z"></path></svg>
                    <svg className="catch-svg svg-three" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="none" viewBox="0 0 1440 320"><path fill-opacity="1" d="M0,224L20,234.7C40,245,80,267,120,250.7C160,235,200,181,240,181.3C280,181,320,235,360,256C400,277,440,267,480,229.3C520,192,560,128,600,133.3C640,139,680,213,720,208C760,203,800,117,840,122.7C880,128,920,224,960,229.3C1000,235,1040,149,1080,128C1120,107,1160,149,1200,176C1240,203,1280,213,1320,229.3C1360,245,1400,267,1420,277.3L1440,288L1440,0L1420,0C1400,0,1360,0,1320,0C1280,0,1240,0,1200,0C1160,0,1120,0,1080,0C1040,0,1000,0,960,0C920,0,880,0,840,0C800,0,760,0,720,0C680,0,640,0,600,0C560,0,520,0,480,0C440,0,400,0,360,0C320,0,280,0,240,0C200,0,160,0,120,0C80,0,40,0,20,0L0,0Z"></path></svg>
                </div>
                <h2>Our <span className="brand-word">Success</span> Stories</h2>
                <p>We equip individuals across the globe with comprehensive Web and Mobile App Development skills to deliver on scalable world-class solutions.</p>
                <div className="wave-div wave-two">
                    <svg className="catch-svg svg-two" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="none" viewBox="0 0 1440 320"><path fill-opacity="1" d="M0,224L34.3,208C68.6,192,137,160,206,165.3C274.3,171,343,213,411,213.3C480,213,549,171,617,181.3C685.7,192,754,256,823,256C891.4,256,960,192,1029,176C1097.1,160,1166,192,1234,213.3C1302.9,235,1371,245,1406,250.7L1440,256L1440,320L1405.7,320C1371.4,320,1303,320,1234,320C1165.7,320,1097,320,1029,320C960,320,891,320,823,320C754.3,320,686,320,617,320C548.6,320,480,320,411,320C342.9,320,274,320,206,320C137.1,320,69,320,34,320L0,320Z"></path></svg>
                    <svg className="catch-svg svg-three" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="none" viewBox="0 0 1440 320"><path fill-opacity="1" d="M0,224L20,234.7C40,245,80,267,120,250.7C160,235,200,181,240,181.3C280,181,320,235,360,256C400,277,440,267,480,229.3C520,192,560,128,600,133.3C640,139,680,213,720,208C760,203,800,117,840,122.7C880,128,920,224,960,229.3C1000,235,1040,149,1080,128C1120,107,1160,149,1200,176C1240,203,1280,213,1320,229.3C1360,245,1400,267,1420,277.3L1440,288L1440,320L1420,320C1400,320,1360,320,1320,320C1280,320,1240,320,1200,320C1160,320,1120,320,1080,320C1040,320,1000,320,960,320C920,320,880,320,840,320C800,320,760,320,720,320C680,320,640,320,600,320C560,320,520,320,480,320C440,320,400,320,360,320C320,320,280,320,240,320C200,320,160,320,120,320C80,320,40,320,20,320L0,320Z"></path></svg>
                </div>
            </div>
            <div className="stories">
                {currentList.length > 0 ?
                    currentList.map(story => (
                        <div key={story.id} className="story-item">
                            <img src={`https://lerntutors.com/storage/stories/${story.simage}`} alt="Story Item" />
                            <div className="item-body">
                                <div className="body-heading">
                                    <h2 className="story-title">{story.stitle}</h2>
                                    <p className="story-date">{new Intl.DateTimeFormat('en-GB').format(new Date(story.sdate))}</p>
                                    <div className="s-img">
                                        <img src="/images/Pattern_course_name.png" alt="Course Name" />
                                    </div>
                                </div>
                                <p className="s-desc">{story.sdesc}</p>
                            </div>
                        </div>
                    ))
                    :
                    <div className="alert alert-info text-center list-empty">Watch this space for our stories</div>
                }
            </div>
            <div className="story-btns">
                <span className="prev-btn" onClick={() => fetchCurrentList(-1)}><FontAwesomeIcon icon={faChevronLeft} /></span>
                <span className="next-btn" onClick={() => fetchCurrentList(1)}><FontAwesomeIcon icon={faChevronRight} /></span>
            </div>
        </div>
    )
}

export default Blog;